import type { Action } from 'react-sweet-state';
import { createStore, createStateHook, createActionsHook } from 'react-sweet-state';

interface RtPaidFeatureEducationStore {
	templatePageIdWebUi: string | null;
}

const initialState: RtPaidFeatureEducationStore = {
	templatePageIdWebUi: null,
};

const actions = {
	setTemplatePageIdWebUi:
		(value: string): Action<RtPaidFeatureEducationStore> =>
		({ setState }) => {
			setState({ templatePageIdWebUi: value });
		},
};

const store = createStore({
	initialState,
	actions,
	name: 'RtPaidFeatureEducationStore',
});

export const useRtPaidFeatureEducationState = createStateHook(store);
export const useRtPaidFeatureEducationActions = createActionsHook(store);
